// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-selected {\n  outline: 1px solid var(--bs-gray-900);\n  outline-offset: 2px;\n}\n.scenario-sim-header {\n  color: var(--bs-dark);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
